import {coreApi} from './core/index'

export const actService = {
    actGetById: (id) => coreApi.get(`act?id=${id}`),
    acts: () => coreApi.get(`act`),
    createAct: (data) => coreApi.post(`act`, data),
    updateAct: (data) => coreApi.put(`act`, data),
    delete: (id) => coreApi.delete(`act/${id}`),
    actCalculates: () => coreApi.get(`act/calculate`),
    actCalculateCreate: (data) => coreApi.post(`act/calculate`, data),
    actCalculateUpdate: (data) => coreApi.put(`act/calculate`, data),
    actCalculateById: (id) => coreApi.get(`act/calculate?id=${id}`),
    paginate: (offset) => coreApi.get(`act/${offset}`),
}